//const URL = '/10_mazedoll/';
const URL = '/ACAL-0010/';


import Vue from 'vue/dist/vue.esm';

import VueRouter from 'vue-router'

import ptop from '@/components/top.vue'
import pintro from '@/components/intro.vue'
import pspecial from '@/components/special.vue'
import pchara from '@/components/character.vue'

import vueSmoothScroll from 'vue-smooth-scroll'
Vue.use(vueSmoothScroll);

Vue.use(VueRouter)

export default new VueRouter({
    mode: 'history',
    routes: [
        { path: URL, component: ptop },
      { path: URL + 'intro/', component: pintro },
      { path: URL + 'special/', component: pspecial },
      { path: URL + 'character/', component: pchara }
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition
        } else {
          return { x: 0, y: 0 }
        }
      }
})
  
  
  
